(function(angular){
	'use strict';
	
	var featuredPropertyItemObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			property: '<'
		},
		controller: [
			'$rootScope',
			'PropertyService',
			FeaturedPropertyItemFunction
		],
		controllerAs: 'featuredPropertyItem'
	};
	
	angular
		.module('featuredPropertyListingModule')
		.component('featuredPropertyItem', featuredPropertyItemObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/featured-property-list/featured-property-item.html';
	}
	
	function FeaturedPropertyItemFunction(
		$rootScope,
		PropertyService
	) {
		var featuredPropertyItem = this;

		featuredPropertyItem.handleClick = function() {
			if(angular.isDefined(featuredPropertyItem.property.legacyPropertyData)) {
				$rootScope.ModalFactory.openReitElement({
					reitElement: featuredPropertyItem.property.legacyPropertyData
				});
			} else {
				PropertyService.getPropertyDetail(featuredPropertyItem.property.elementId).then(
					function(propertyDetail) {
						$rootScope.ModalFactory.openReitElement({
							reitElement: propertyDetail
						});
					}
				);
			}
		};
	}
})(window.angular);